<script>
  import {
    currentQuote,
    theme,
    loading,
    isDownloadOpen,
    isShareOpen,
  } from "../stores/store";
  import { getRandomQuote, getQuote } from "../utils/quote";

  import type { Quote } from "../components/interfaces/quote";

  import Loading from "./common/loading.svelte";

  export let currentRoute: any;
  let quote: Quote;

  $: quote = $currentQuote;

  let urlHostName: string = window.location.origin;
  $: themeValue = $theme === "dark" ? 0 : 1;

  function updateURL(URL: string) {
    return window.history.pushState({}, "", URL);
  }

  async function getNewQuote() {
    loading.set(true);
    isShareOpen.set(false);
    isDownloadOpen.set(false);
    let nextQuote = await getRandomQuote();
    currentQuote.set(nextQuote);
    updateURL(urlHostName + "/?q=" + nextQuote["_id"] + themeValue);
    setTimeout(() => {
      loading.set(false);
    }, 500);
  }

  (async () => {
    if (currentRoute.queryParams.q) {
      loading.set(true);
      // Get query parameters
      let param: string = currentRoute.queryParams.q;
      // Remove Theme Value
      let filteredParam: string = param.slice(currentRoute.queryParams.q, -1);
      // Get Theme Value
      let getThemeValue: Number = parseFloat(param.slice(-1));
      // Set theme based on Theme Value
      theme.set(getThemeValue === 0 ? "dark" : "light");
      // Get Quote based on params
      quote = await getQuote(filteredParam);
      currentQuote.set(quote);
      loading.set(false);
    } else {
      loading.set(true);
      quote = await getRandomQuote();
      currentQuote.set(quote);
      loading.set(false);
    }
  })();
</script>

<div class="quote-wrapper">
  {#if !$loading}
    <div class="quote">
      {#if quote}
        <figure>
          <blockquote class={quote.class}>
            {quote.content}
          </blockquote>
          <figcaption>{quote.author}</figcaption>
        </figure>
      {/if}
    </div>
    <div class="refresh">
      <button on:click={getNewQuote} class="newQuote">
        <i class="far fa-2x fa-redo-alt" />
      </button>
    </div>
  {:else}
    <Loading />
  {/if}
</div>

<style lang="scss">
  .quote-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 50vh;
    width: 75vw;
  }
  .quote {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
  }
  .refresh {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  figure {
    margin: 0;
    padding: 0;
    blockquote {
      margin: 0 0 45px 0;
      padding: 0;
      line-height: normal;
      &.quoteSmall {
        font-size: 8em;
        line-height: 130%;
      }
      &.quoteMedium {
        font-size: 6em;
        line-height: 135%;
      }
      &.quoteLarge {
        font-size: 4em;
        line-height: 150%;
      }
      &.quoteXLarge {
        font-size: 3.5em;
        line-height: 150%;
      }
    }
    figcaption {
      font-size: $fontSize-medium;
      font-style: italic;
      opacity: 0.65;
    }
  }
  button {
    border: 0;
    margin: 0;
    background: none;
  }
</style>
